/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    useState,
    useEffect,
  } from 'react'

  import { Helmet } from "react-helmet";
  import { useIntl } from 'react-intl';
  import { useSelector, shallowEqual, useDispatch } from 'react-redux';
  import { getDay, parseISO, format } from 'date-fns';
  import _ from "lodash";

  import { useLocation, useNavigate } from 'react-router-dom';
  import Lottie from "lottie-react";

  import LoadingContent from 'app/modules/loading/LoadingContent';
  import blink from '../../../_metronic/assets/animations/blink.json';
  import blinkConfirmed from '../../../_metronic/assets/animations/blinkConfirmed.json';
  import PurchaseMenu from 'app/utils/PurchaseMenu';

  import {
    fetchCreditPurchases,
  } from 'app/services/creditPurchases';

  import {
    formatLongDateTime,
  } from 'app/services/dates';

import {
  formatMoney,
} from 'app/services/intFormat';

  const CreditPurchaseList = () => {
    const { creditPurchases, auth } = useSelector((state : any) => ({
      creditPurchases: state.creditPurchases,
      auth: state.auth,
    }), shallowEqual);

    const intl = useIntl();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [list, setList] = useState<any>([]);

    const getBranchName = (value, first = true) => {
      if (value.relationships.origin.type === 'service') {
        return value.relationships.origin.relationships.fields[0].relationships.branch.attributes.name
      }

      if (value.relationships.origin.type === 'plan') {
        return first ?
          value.relationships.origin.relationships.branches[0].attributes.name :
          _.map(value.relationships.origin.relationships.branches, 'attributes.name')
      }
    }

    const getTypeLabel = (value) => {
      if (value.relationships.origin.type === 'plan') {
        if (value.relationships.origin.attributes.type === 'day_use') {
          return 'Day use';
        }
      }

      if (value.relationships.origin.type === 'service') {
        if (value.relationships.origin.attributes.modality === 'reservation') {
          return 'Locação';
        }
        if (value.relationships.origin.attributes.modality === 'class') {
          return 'Aula';
        }
      }

      return value.relationships.origin.attributes.type;
    }

    useEffect(() => {
      dispatch<any>(fetchCreditPurchases()).then((value) => {
        setList(value)
      });
    }, []);

    useEffect(() => {
      if(!auth.user) {
        navigate('/')
      }
    }, [auth]);

    const showItem = (item: any) => {
      return <div className="col-lg-6 mb-1 mb-lg-0">
        <div className="d-flex justify-content-center">
          <div
            className="card card-dashed flex-row flex-stack p-4 mb-6 w-100 cursor-pointer"
            onClick={() => navigate(`/compras/pacotes-de-creditos/${item.id}`)}
          >
            <div className="d-flex align-items-center me-2">
              <div className="flex-grow-1">
                <div className="d-flex align-items-center fs-2 fw-bold flex-wrap pb-3">{item?.relationships?.origin?.attributes?.name}</div>
                <div className="fs-7 fw-semibold text-gray-700 pb-1">{getBranchName(item)}</div>
                <div className="fs-7 fw-semibold text-gray-700 pb-3">{item?.attributes?.amount} {item?.attributes?.amount > 1 ? 'Créditos' : 'Crédito'} - {getTypeLabel(item)}</div>
                <div className="fs-7 fw-semibold text-gray-700 pb-3">Realizado {formatLongDateTime(item?.attributes?.created_at)}</div>
                <div className="fs-7 fw-semibold text-gray-900 text-primary zi-10">
                  {formatMoney(item?.attributes?.price)}
                </div>
              </div>
            </div>
            <div className="d-flex ms-5">
              <div className="flex-grow-1 text-uppercase">
                {(item.relationships.status.attributes.name === 'paid') && <span className="flex d-flex text-primary fs-6 fw-bold">
                  Pago
                </span>}

                {(item.relationships.status.attributes.name === 'pending') && <span className="flex d-flex text-warning fs-6 fw-bold text-center">
                  Pendente
                </span>}

                {(item.relationships.status.attributes.name === 'canceled') && <span className="flex d-flex opacity-50 fs-6 fw-bold text-center">
                  Cancelado
                </span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    return (<>

      <Helmet>
        <title>Minhas compras - Pacote de créditos - Atacante App</title>
      </Helmet>

      <PurchaseMenu />

      {<div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0 mb-13'>
          {list.length > 0 && <>
            <div className="mb-10">
              <h1 className="mb-3">
                Pacotes de créditos adquiridos
              </h1>
            </div>
            <div className="row mt-10">
              {list.map(item => {
                return showItem(item)
              })}
            </div>
          </>}

          {creditPurchases.listLoading === false && list.length === 0 && <div className="my-10 text-center">
            <h2 className="mb-3">
              Você não efetuou nenhuma compra
            </h2>
            <div className="text-muted fw-semibold fs-5">
              Garanta descontos exclusivos para jogar com seus amigos!
            </div>
          </div>}

          {creditPurchases.listLoading === true && list.length === 0 && <LoadingContent />}
        </div>
      </div>}
    </>)
  }

  export {
    CreditPurchaseList
  }
